import create from "zustand";
import { produce } from "immer";

const STORE = {
  sections: [],
  activeSection: {}
};

const createWithImmer = (storeCreator) =>
  create((originalSet, originalGet) =>
    storeCreator((fn) => originalSet(produce(fn)), originalGet)
  );

export const useSectionStore = createWithImmer((setState, getState) => ({
  ...STORE,
  addSection: (data) => {
    let sections = getState().sections;
    if (sections.findIndex((section) => section.id === data.id) === -1) {
      setState(() => {
        return { sections: [...sections, data] };
      });
    }
  },
  updateSectionVisibility: (id, isHidden, accrodianGroup) => {
    let sections = getState().sections;
    sections = sections.map((data) => {
      let section = { ...data };
      if (section.id === id) {
        section.isHidden = isHidden;
        if (accrodianGroup) {
          section.accrodianGroup = accrodianGroup;
        }
      }
      return section;
    });
    setState(() => {
      return { sections: sections };
    });
  },
  reset: () => {
    setState(() => ({
      ...STORE
    }));
  }
}));
